import { useState } from "react";
import WalletView from "./view";
import { useNavigate } from "react-router-dom";
import useRecharges from "@/hooks/extract/recharges";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { getCustomerData } from "@/redux/ducks/customer";
import { getFormattedValue } from "@/utils/functions";

export default function Wallet() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isVisibleFilter, setIsVisibleFilter] = useState(false);
  const [isShowingMenu, setIsShowingMenu] = useState(false);

  const callbackRefresh = () => {
    setIsRefreshing(false);
  }

  const {
    isLoading,
    requestRecharges,
    items,
    selectedFilter,
    setSelectedFilter,
  } = useRecharges(callbackRefresh);

  const goBack = () => navigate("/");

  const goToRecharge = () => navigate('/payment');

  const toggleMenu = () => setIsShowingMenu(isShowingMenu => !isShowingMenu);
  const toggleFilterModal = () => setIsVisibleFilter(isVisibleFilter => !isVisibleFilter);

  const filter = () => {
    requestRecharges(selectedFilter!);
    toggleFilterModal();
  }

  const refresh = () => {
    if (isRefreshing) return;

    setIsRefreshing(true);
    requestRecharges(selectedFilter!);
    dispatch(getCustomerData());
  }

  return (
    <WalletView
      items={items!}
      isLoading={isLoading! || isRefreshing}
      goBack={goBack}
      goToRecharge={goToRecharge}
      balance={getFormattedValue(customer?.account?.balance ?? 0)}
      setSelectedFilter={setSelectedFilter}
      selectedFilter={selectedFilter}
      filter={filter}
      isVisibleFilter={isVisibleFilter}
      toggleFilterModal={toggleFilterModal}
      isShowingMenu={isShowingMenu}
      toggleMenu={toggleMenu}
      refresh={refresh}
    />
  );
}
